import { useEffect, useState } from 'react';
import React from "react";
import { useDispatch, useSelector } from 'react-redux';
import { Link } from 'react-router-dom'
import {
    documentIndex,
    documentStatusUpdate,
    searchByRequest,
    documentStore
} from '../../features/dashboard/DocumentSlice';
import { userDocumentStatus } from '../../features/dashboard/DocumentStatusSlice'
import { userList } from '../../features/dashboard/UserSlice';
import Loading from '../../Loading';
import Header from './Header';
import Broadcast from './Broadcast';
import { ToastContainer, toast } from 'react-toastify';
import { Calendar } from "react-multi-date-picker";
import DatePicker, { DateObject } from "react-multi-date-picker"
import persian from "react-date-object/calendars/persian"
import gregorian from "react-date-object/calendars/gregorian"
import persian_fa from "react-date-object/locales/persian_fa"
import gregorian_en from "react-date-object/locales/gregorian_en"
import persian_en from "react-date-object/locales/persian_en"
import Button from '../../component/form/Button';
import Input from '../../component/form/Input';
import DataTable, { ExpanderComponentProps } from 'react-data-table-component';
import axios from 'axios';
import { host } from '../../function/api'
import * as Icon from 'react-feather';
import $ from 'jquery'
import { saveAs } from 'file-saver';
import * as moment from 'jalali-moment';
import { Tooltip } from 'react-tooltip'
import 'react-tooltip/dist/react-tooltip.css'
import { confirmAlert } from 'react-confirm-alert';
import 'react-confirm-alert/src/react-confirm-alert.css'


function DocumentIndex() {

   

    const dispatch = useDispatch()
    const [status, setStatus] = useState(true)
    const token = localStorage.getItem('token')
    const date = new DateObject({ calendar: persian, locale: persian_fa })
    const [RahpardaznetMobile, setًRahpardaznetMobile] = useState('');
    const [RahpardaznetCode, setRahpardaznetCode] = useState('');
    const [RahpardaznetHash, setRahpardaznetHash] = useState('');
    const [RahpardaznetValidationStatus, setRahpardaznetValidationStatus] = useState('');
    const [BtnSms, setBtnSms] = useState('');
    const [RahpardaznetStatus, setRahpardaznetStatus] = useState('');
    const [RahpardaznetId, setRahpardaznetId] = useState('');
    const [RahpardaznetFilterStatus, setRahpardaznetFilterStatus] = useState('');
    const [RahpardaznetFilterUser, setRahpardaznetFilterUser] = useState('');
    const [RahpardaznetFilterType, setRahpardaznetFilterType] = useState('1');
    const [start_date, setStart_date] = useState({})
    const [end_date, setEnd_date] = useState({})
    const [RahpardaznetMessage, setRahpardaznetMessage] = useState('')
    const [RahpardaznetNoteMessage, setRahpardaznetNoteMessage] = useState('')
    const [RahpardaznetNoteMessageStatus, setRahpardaznetNoteMessageStatus] = useState('')

    const [RahpardaznetDocumentID, setRahpardaznetDocumentID] = useState('')
    const [RahpardaznetStatusID, setRahpardaznetStatusID] = useState('')
    const [RahpardaznetDetailsData, setRahpardaznetDetailsData] = useState({})
    const [fake_date, setFake_date] = useState({})
    const {
        documents,
        message,
        loading,
        update,
        errorNumber,
        errorNumberType
    } = useSelector(state => state.document)

    const { statuses } = useSelector(state => state.status)
    const { users } = useSelector(state => state.user)

    const [number, setNumber] = useState()
    const [numberType, setNumberType] = useState()
    const [RahpardaznetLoading, setRahpardaznetLoading] = useState()
    const [RahpardaznetRandomString, setRahpardaznetRandomString] = useState()
    const columns = [
        {
            name: '#',
            sortable: false,
            cell: row => <div className='rahpardaznet-border'>{row.id} </div>,

        },
        {

            name: 'شماره سند',
            sortable: false,
            cell: row => <div className='rahpardaznet-border'>{row.mt_sanadno}</div>
        },
        {
            name: 'شماره پلاک',
            sortable: false,
            cell: row => row.mt_pelakserial == "" ? (<span></span>) : (
                <div className="rk-pelak-back"><span>{row.mt_pelakserial}</span><span>{row.mt_pelakno}</span></div>),
        },
        {
            name: 'شماره بدنه',
            sortable: false,
            cell: row => <div className="rahpardaznet-border font-en">{row.mt_bodyno}</div>
        },
        {
            name: 'شماره موتور',
            sortable: false,
            cell: row => <div className="rahpardaznet-border font-en">{row.mt_motorno}</div>
        },
        {
            name: 'نام و نام خانوادگی',
            sortable: false,
            cell: row => <div className="rahpardaznet-border">{row.customer_fullname}</div>
        },
        {
            name: 'کدملی',
            sortable: false,
            cell: row => <div className="rahpardaznet-border font-en">{row.customer_national_code}</div>
        },
        {
            name: 'وضعیت',
            cell: row => row.flag === null ? (
                <div className='rahpardaznet-border'><span className='badge text-danger'>سند ناموجود</span>
                </div>) : (
                <div className='rahpardaznet-border'><strong className='badge text-dark' data-bs-toggle="collapse"
                    href={'#collapseExample' + row.id}
                    role="button">{row.status_document_id}</strong></div>)

        },
        {
            name: 'عملیات',
            cell: row => <div className='rahpardaznet-table-btn'>
                <span>
                    <Link
                        to={`/dashboard/document/transfers/${row.id}`}
                        className='rahpardaznet-icon-table'
                        data-tooltip-id={"tooltip-transfer-" + row.id}
                        data-tooltip-content='سند الکترونیک'
                        data-tooltip-place="top"
                    >
                        <i className="fa-solid fa-eye fa-fw"></i>
                    </Link>
                    <Tooltip id={"tooltip-transfer-" + row.id} style={{ backgroundColor: "#767676", color: "#fff" }} />
                </span>
                <span>
                    <Link
                        to={`/dashboard/document/edit/${row.id}`}
                        className='rahpardaznet-icon-table'
                        data-tooltip-id={"tooltip-edit-" + row.id}
                        data-tooltip-content='ویرایش سند'
                        data-tooltip-place="top"
                    >
                        <i className="fa-regular fa-pen-to-square fa-fw"></i>
                    </Link>
                    <Tooltip id={"tooltip-edit-" + row.id} style={{ backgroundColor: "#767676", color: "#fff" }} />
                </span> 
               
                <span>
                    <Link
                        to={`/dashboard/document/fiscal/${row.id}`}
                        className='rahpardaznet-icon-table'
                        data-tooltip-id={"tooltip-edit-" + row.id}
                        data-tooltip-content='بخش مالی'
                        data-tooltip-place="top"
                    >
                        <i className="fa-regular fa-dollar-sign fa-fw"></i>
                    </Link>
                    <Tooltip id={"tooltip-edit-" + row.id} style={{ backgroundColor: "#767676", color: "#fff" }} />
                </span> 
                {
                    (row.deletePermission === true) ? (
                       
                                <button type="button" 
                                    onClick={(e) => documentDeletedConfirm(row.id)} className='rahpardaznet-icon-table'><i
                                        className="fa-solid fa-trash fa-fw"></i> </button>
                          

                    ) : null
                }
            </div>
        },


    ];
    const ExpandedComponent = ({ data }) => (


        statuses.length > 0 ? (

            statuses.map((row, key) => (
                (data.status_document_id == row.name) ? (
                    <button className='rahpardaznet-change-status active m-2' key={key} id={row.id} disabled>
                        {row.name}
                    </button>
                ) : (
                    <button type='button' className='rahpardaznet-change-status m-2' key={key} id={row.id}
                        onClick={(e) => documentStatusUpdateHandler(row.id, data.mt_sanadno)}>
                        {row.name}
                    </button>
                )
            ))
        ) : null
    )

    const rahpardazneRestForm = (event) => {
        event.preventDefault()
        setRahpardaznetFilterStatus('0');
        setRahpardaznetFilterUser('0');
        setRahpardaznetFilterType('1');
        setStart_date({});
        setEnd_date({});
        setPinCode("");
        $('.rk-search-bar').children('input').val('');
        
        getUserList();
        toast.success("فرم با موفقیت پاکسازی شد.", {
            position: "top-center",
            autoClose: 1200,
        })

    }

    const rahpardaznetExportExcel = async (event) => {
        event.preventDefault()
        if(typeof end_date == 'object' || end_date == "" || typeof start_date == 'object' || start_date == "" ){
            toast.error("انتخاب بازه تاریخ الزامی می باشد.", {
                position: "top-center",
                autoClose: 1200,
            })
            return;
        }
        setRahpardaznetLoading('1');
        const data = {
            'status': RahpardaznetFilterStatus ? RahpardaznetFilterStatus : '',
            'user': RahpardaznetFilterUser ? RahpardaznetFilterUser : '',
            'type': RahpardaznetFilterType ? RahpardaznetFilterType : '',
            'start': start_date ? start_date : '',
            'end': end_date ? end_date : '',

        }
        try {
            const response = await axios({
                method: 'POST',
                url: `${host}documentExportExcel`,
                data: data,
                responseType: 'arraybuffer',
                timeout: 1000000000,
                headers: {
                    'Content-Type': 'application/x-www-form-urlencoded',
                    'Accept': 'Application/json',
                    'xsrfHeaderName': "X-XSRF-TOKEN",
                    'withCredentials': true,
                    'Authorization': `Bearer ${localStorage.getItem('token')}`
                }
            })
            var blob = new Blob([response.data], { type: "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet" });

            saveAs(blob, "export-document" + ".xlsx");
            setRahpardaznetLoading(' ');


        } catch (error) {
            setRahpardaznetLoading(' ');
            console.log(error);
            toast.error('خروجی با موفقیت ایجاد نشد.', {
                position: "top-center",
                autoClose: 1200,
            })
            // if(typeof (error.response) == 'object'){
            //     const listError = error.response.data.error;
            //     // console.log(listError);

            //     $.each(listError, function (index, value) {
            //         // error+index = value[0];
            //         if (typeof (value) == 'object') {
            //             toast.error(value[0], {
            //                 position: "top-center",
            //                 autoClose: 5000,
            //             })
            //         } else {
            //             toast.error(value, {
            //                 position: "top-center",
            //                 autoClose: 5000,
            //             })
            //         }
            //     });
            // }
        }
    }
   

    const documentStatusUpdateHandler = async (status, id) => {
      
        const data = {
            id: id,
            status: status
        }
        setRahpardaznetDocumentID(id);
        setRahpardaznetStatusID(status);
        setًRahpardaznetMobile(' ');
        setRahpardaznetCode(' ');
        setRahpardaznetHash(' ');
        setRahpardaznetValidationStatus(' ');
        setRahpardaznetNoteMessage(false);
        setRahpardaznetNoteMessageStatus(false);
        $('#rahpardaznet-receipt-status, #rahpardaznet-receipt').prop('checked', false);
        setRahpardaznetId(id);
        setRahpardaznetStatus(status);
        if (status == '7') {
            try {
                const response = await axios({
                    method: 'POST',
                    url: `${host}document/status/owner/mobile`,
                    data: data,
                    headers: {
                        'Accept': 'application/json',
                        'Authorization': `Bearer ${localStorage.getItem('token')}`,
                        'xsrfHeaderName': "X-XSRF-TOKEN",
                        'withCredentials': true,
                    }
                })
                console.log(response.data);
                if (response.data.mobile == "") {
                    toast.error("شماره موبایل مالک یافت نشد.", {
                        position: "top-center",
                        autoClose: 1200,
                    })

                } else {
                    setًRahpardaznetMobile(response.data.mobile);
                }


            } catch (error) {
                toast.error("شماره موبایل مالک یافت نشد.", {
                    position: "top-center",
                    autoClose: 1200,
                })
            }
            $('.modalOwnerMobile').trigger('click');
        } else {
            setRahpardaznetMessage(' ');
         
            let r = (Math.random() + 1).toString(36).substring(7);
            console.log('-------------------------------------------------------');
            console.log(id);
            console.log('-------------------------------------------------------');
            
            $('.rahprdaznet-file-loading').html('<div className="file-loading"><input id="image-file'+id+'" type="file" name="file" accept="image/*" data-min-file-count="1" data-preview-file-type="text"  multiple /></div>');
            $("#image-file"+id).fileinput({
                theme: 'fa',
                uploadUrl: `${host}document/status/upload-image`,
                uploadExtraData: function () {
                    return {
                        'code': r,
                        'mt_sanadno': id,
                        'statusid': status
                    };
                },
                allowedFileExtensions: ['jpg', 'png', 'gif', 'jpeg', 'pdf'],
                overwriteInitial: false,
                maxFileSize: 2048,
                maxFilesNum: 10
            });
            setRahpardaznetRandomString(r);

            getDocumentDetails(id, status);


            $('.fileinput-remove-button').trigger('click');
            $('.modalDocuments').trigger('click');

            return;
            // try {
            //     const response = await axios({
            //         method: 'POST',
            //         url: `${host}document/status/update`,
            //         data: data,
            //         headers: {
            //             'Accept': 'application/json',
            //             'Authorization': `Bearer ${localStorage.getItem('token')}`,
            //             'xsrfHeaderName': "X-XSRF-TOKEN",
            //             'withCredentials': true,
            //         }
            //     })
            //
            //     if (response.data.status == true) {
            //         toast.success(response.data.message, {
            //             position: "top-center",
            //             autoClose: 1200,
            //         })
            //         getUserList();
            //     }
            //
            // } catch (error) {
            //     toast.error("ویرایش نا موفق بود.", {
            //         position: "top-center",
            //         autoClose: 1200,
            //     })
            // }
        }

        // getUserList();
    }

    const documentSearchHandler = (e) => {
        e.preventDefault()
        const data = {
            'number': number,
            'numberType': numberType
        }
        dispatch(searchByRequest(data));
    }

    useEffect(() => {
        dispatch(documentIndex(token))
        dispatch(userDocumentStatus(token))
        dispatch(userList());
        if (update === true && status === true) {
            toast.success(message, {
                position: "top-center",
                autoClose: 600,
            })
            setStatus(false)
            // message = ''
        }
    }, [update])

    const [ListDocument, setListDocument] = useState({});
    const [page, setPage] = useState(1);
    const countPerPage = 20;

    const getUserList = async (search = pinCode, pageNumber = page, status = RahpardaznetFilterStatus, user = RahpardaznetFilterUser, type = RahpardaznetFilterType, start = start_date, end = end_date) => {
        $('.dlUCce').addClass('loading');
        try {
            start = typeof start == 'object' ? '0' : start;
            end = typeof end == 'object' ? '0' : end;
            const response = await axios({
                method: 'GET',
                url: `${host}document?page=${pageNumber}&per_page=${countPerPage}&search=${search}&delay=1&status=${status}&user=${user}&type=${type}&start=${start}&end=${end}`,
                headers: {
                    'Accept': 'application/json',
                    'Authorization': `Bearer ${localStorage.getItem('token')}`,
                    'xsrfHeaderName': "X-XSRF-TOKEN",
                    'withCredentials': true,
                }
            })
            var userList = JSON.stringify(response.data);
            setListDocument(response.data);
            $('.dlUCce').removeClass('loading');

        } catch (error) {
            setListDocument({});
            $('.dlUCce').removeClass('loading');
        }
    };



    const getDocumentDetails = async (mt_sanadno, status) => {

        try {
            const data = {
                'mt_sanadno': mt_sanadno,
                'status': status,
            }
            const response = await axios({
                method: 'post',
                url: `${host}document/details`,
                data: data,
                headers: {
                    'Accept': 'application/json',
                    'Authorization': `Bearer ${localStorage.getItem('token')}`,
                    'xsrfHeaderName': "X-XSRF-TOKEN",
                    'withCredentials': true,
                }
            })
            setRahpardaznetDetailsData(response.data.data);

        } catch (error) {
            toast.error("خطایی پیش آمد مجددا تلاش نمایید.", {
                position: "top-center",
                autoClose: 1200,
            })
        }
    };


    function searchByDataTable(event) {
        let delayTimeOutFunction;
        delayTimeOutFunction = setTimeout(() => {
            getUserList(event.target.value);


        }, 3000); // denounce delay

        return () => clearTimeout(delayTimeOutFunction);

    };


    const validationCodeHandler = async (e) => {
        e.preventDefault();
        setBtnSms('1');
        const data = {
            mobile: RahpardaznetMobile,
            code: RahpardaznetCode,
            hash: RahpardaznetHash
        }


        try {
            const res = await axios({
                method: 'POST',
                url: `${host}customer/mobile/validationCode`,
                data: data,
                headers: {
                    'Accept': 'application/json',
                    'Authorization': `Bearer ${localStorage.getItem('token')}`,
                    'xsrfHeaderName': "X-XSRF-TOKEN",
                    'withCredentials': true,
                }
            })
            if (res.data.status) {
                toast.success("اعتبار سنجی با موفقیت انجام شد.", {
                    position: "top-center",
                    autoClose: 1200,
                })
                setBtnSms('2');
                $('.close').trigger('click');


                setRahpardaznetMessage(' ');
                setRahpardaznetDocumentID(RahpardaznetId);
                setRahpardaznetStatusID(RahpardaznetStatus);


                let r = (Math.random() + 1).toString(36).substring(7);
                $("#image-file").fileinput({
                    theme: 'fa',
                    uploadUrl: `${host}document/status/upload-image`,
                    uploadExtraData: function () {
                        return {
                            'code': r,
                            'mt_sanadno': RahpardaznetDocumentID,
                            'statusid': RahpardaznetStatusID
                        };
                    },
                    allowedFileExtensions: ['jpg', 'png', 'gif', 'jpeg', 'pdf'],
                    overwriteInitial: false,
                    maxFileSize: 2048,
                    maxFilesNum: 10
                });
                setRahpardaznetRandomString(r);

                getDocumentDetails(RahpardaznetId, RahpardaznetStatus);

                $('.fileinput-remove-button').trigger('click');
                $('.modalDocuments').trigger('click');



            } else {
                toast.error("کد تایید نامعتبر است.", {
                    position: "top-center",
                    autoClose: 1200,
                })

                setBtnSms(' ');
            }

        } catch (error) {
            toast.error("کد تایید نا معتبر است.", {
                position: "top-center",
                autoClose: 1200,
            })

            setBtnSms(' ');
        }


        // dispatch(mobileVerificationCode(data))
        // console.log(sms_status);

    }


    const VerificationCodeHandler = async (e) => {
        e.preventDefault();
        setBtnSms('1');
        const data = {
            mobile: RahpardaznetMobile ? RahpardaznetMobile : null
        }


        setRahpardaznetHash(" ");

        try {
            const res = await axios({
                method: 'POST',
                url: `${host}customer/mobile/verificationCode`,
                data: data,
                headers: {
                    'Accept': 'application/json',
                    'Authorization': `Bearer ${localStorage.getItem('token')}`,
                    'xsrfHeaderName': "X-XSRF-TOKEN",
                    'withCredentials': true,
                }
            })
            if (res.status == 200) {
                toast.success("پیامک با موفقیت ارسال شد.", {
                    position: "top-center",
                    autoClose: 1200,
                })


                setBtnSms(' ');
                setRahpardaznetHash(res.data.hash);
                setRahpardaznetValidationStatus('1');
            } else {
                toast.error("پیامک ارسال نشد.", {
                    position: "top-center",
                    autoClose: 1200,
                })

                setBtnSms(' ');
            }

        } catch (error) {
            toast.error("پیامک ارسال نشد.", {
                position: "top-center",
                autoClose: 1200,
            })

            setBtnSms(' ');
        }
        // dispatch(mobileVerificationCode(data))
        // console.log(sms_status);

    }

    const [dateObject, setDateObject] = useState(
        new DateObject()
    );

    const convert_end = (date, format = 'YYYY-MM-DD') => {
        let object = { date, format }
        setEnd_date(new DateObject(object).convert(gregorian, gregorian_en).format())
    }
    const convert_start = (date, format = 'YYYY-MM-DD') => {
        let object = { date, format }

        setStart_date(new DateObject(object).convert(gregorian, gregorian_en).format(format))

    }
    const convert_fake = (date, format = 'YYYY-MM-DD') => {
        let object = { date, format }

        setFake_date(new DateObject(object).convert(gregorian, gregorian_en).format(format))

    }





    const [pinCode, setPinCode] = useState("");
    useEffect(() => {
        getUserList()
    }, []);
    const rahkarpardaznet_search_datatable = (e) => {
        e.preventDefault();
        setPage(1);
        setRahpardaznetFilterStatus('0');
        setRahpardaznetFilterUser('0');
        setRahpardaznetFilterType('1');
        setStart_date({ date: ' ' });
        setEnd_date({ date: ' ' });
        console.log(RahpardaznetFilterUser);
        $('#pagination-first-page').trigger('click');
        getUserList(pinCode, 1, '0', '0', '1', '0', '0');
    }
    const handlePageChange = (page) => {
        setPage(page);
        getUserList(pinCode, page);
    };

    const RahpardaznetDefaultNote = (message) => {
        setRahpardaznetMessage(RahpardaznetMessage + " " + message);
    }
    const RahpardaznetSubmitChangeStatus = async (e) => {
        e.preventDefault()
        const data = {
            'mt_sanadno': RahpardaznetId,
            'status': RahpardaznetStatus,
            'smsStatus': RahpardaznetNoteMessageStatus,
            'smsNoteStatus': RahpardaznetNoteMessage,
            'hash_code': RahpardaznetRandomString,
            'fake_date': fake_date,
            'fake_date_fa': moment(fake_date).locale('fa').format('YYYY/MM/DD HH:mm:ss')
        }

        try {
            const response = await axios({
                method: 'POST',
                url: `${host}document/status/update`,
                data: data,
                headers: {
                    'Accept': 'application/json',
                    'Authorization': `Bearer ${localStorage.getItem('token')}`,
                    'xsrfHeaderName': "X-XSRF-TOKEN",
                    'withCredentials': true,
                }
            })

            if (response.data.status == true) {
                toast.success(response.data.message, {
                    position: "top-center",
                    autoClose: 1200,
                })
                setRahpardaznetMessage(' ');
                $('.fileinput-remove-button').trigger('click');
                $('.modalDocuments').trigger('click');
                getUserList();
            }

        } catch (error) {
            toast.error("ویرایش نا موفق بود.", {
                position: "top-center",
                autoClose: 1200,
            })
        }
    };


    useEffect(() => {








    }, [])


    const rahpardaznetFilterRequest = () => {
        
        if(typeof end_date == 'object' || end_date == "" || typeof start_date == 'object' || start_date == "" ){
            toast.error("انتخاب بازه تاریخ الزامی می باشد.", {
                position: "top-center",
                autoClose: 1200,
            })
            return;
        }
        setPinCode("");
        $('.rk-search-bar').children('input').val('');
        getUserList();

    }

    const RahpardaznetSubmitMessage = async (e) => {
        e.preventDefault()
        if (RahpardaznetMessage == null || RahpardaznetMessage == " ") {
            toast.error("یادداشت خالی می باشد.", {
                position: "top-center",
                autoClose: 1200,
            })
            return;
        }
        // alert(RahpardaznetMessage);
        const data = {
            'message': RahpardaznetMessage,
            'mt_sanadno': RahpardaznetDocumentID,
            'status_id': RahpardaznetStatusID
        }
        try {
            const response = await axios({
                method: 'POST',
                url: `${host}document/status/message`,
                data: data,
                headers: {
                    'Accept': 'application/json',
                    'Authorization': `Bearer ${localStorage.getItem('token')}`,
                    'xsrfHeaderName': "X-XSRF-TOKEN",
                    'withCredentials': true,
                }
            })

            if (response.data.status == true) {
                toast.success('یادداشت با موفقیت ایجاد شد.', {
                    position: "top-center",
                    autoClose: 1200,
                })
                getDocumentDetails(RahpardaznetDocumentID, RahpardaznetStatusID);
                $(".rahpardaznet-list-message").animate({
                    scrollTop: $('.rahpardaznet-list-message').get(0).scrollHeight
                }, 1500);
                setRahpardaznetMessage(' ');

            }

        } catch (error) {
            toast.error("یادداشت اضافه نشد.", {
                position: "top-center",
                autoClose: 1200,
            })
        }
    };


    const documentDeletedConfirm = (id) => {
        confirmAlert({
            title: 'آیا از حذف سند مطمئن هستید؟',
            message: 'با حذف سند تمامی فایل های ضمیمه و یادداشت ها و انتقال های سند حذف خواهد شد.',
            buttons: [
                {
                    label: 'حذف',
                    onClick: () => documentDeleteHandler(id)
                },
                {
                    label: 'لغو',
                }
            ]
        })
    };

    const documentDeleteHandler = async (id) => {

        const data = {
            document_id: id,
        }




        try {
            const response = await axios({
                method: 'POST',
                url: `${host}document/delete`,
                data: data,
                headers: {
                    'Accept': 'application/json',
                    'Authorization': `Bearer ${localStorage.getItem('token')}`,
                    'xsrfHeaderName': "X-XSRF-TOKEN",
                    'withCredentials': true,
                }
            })

            if (response.data.status == true) {
                toast.success(response.data.message, {
                    position: "top-center",
                    autoClose: 1200,
                })
                getUserList();
            }

        } catch (error) {
            toast.error("حذف سند ناموفق بود.", {
                position: "top-center",
                autoClose: 1200,
            })
        }


    }

    return (
        <>


            <button type="button" className="d-none modalDocuments" data-toggle="modal" data-backdrop="static"
                data-keyboard="false" data-target="#modalDocuments"></button>

            <div className="modal modal-xl  fade" id="modalDocuments">
                <div className="modal-dialog modal-dialog-centered" role="document">
                    <div className="modal-content">
                        <div className="modal-header">
                            <h5 className="modal-title" id="exampleModalLabel">تغیر وضعیت سند</h5>
                            <button type="button" className="close" data-dismiss="modal" aria-label="Close">
                                <span aria-hidden="true">&times;</span>
                            </button>
                        </div>

                        <div className="modal-body">
                            <div className="row">
                                <div className="col-12 col-md-7 input-100">
                                    <DatePicker
                                        tabIndex="1"
                                        calendar={persian}
                                        locale={persian_fa}
                                        calendarPosition="bottom-right"
                                        value={fake_date.date ? fake_date.date : null}
                                        onChange={convert_fake}
                                    />
                                    <div className="mt-3">
                                        <div className="form-group rahpardaznet-small-file rahprdaznet-file-loading">
                                            <div className="file-loading">
                                                <input 
                                                    id="image-file"
                                                    type="file"
                                                    name="file"
                                                    accept="image/*"
                                                    data-min-file-count="1"
                                                    data-preview-file-type="text"
                                                    multiple />
                                            </div>
                                        </div>
                                    </div>
                                </div>
                                <div className="col-12 col-md-5">
                                    <div className="container">
                                        <div className="rahpardaznet-list-message">

                                            {
                                                (typeof RahpardaznetDetailsData == 'object' && RahpardaznetDetailsData.length > 0) ? (
                                                    <>
                                                        {
                                                            RahpardaznetDetailsData.map((note, key) => (
                                                                <div className="message-candidate center-block">
                                                                    <div className="row rahpardaznet-message-details">
                                                                        <div className="col-xs-8 col-md-6 p-0">
                                                                            <h6 className="message-name"> {note.user_id}</h6>
                                                                        </div>
                                                                        <div className="col-xs-4 col-md-6 p-0 text-left message-date">
                                                                            {moment(note.created_at).locale('fa').format('YYYY/MM/DD HH:mm:ss')}
                                                                        </div>
                                                                    </div>
                                                                    <div className="row message-text">
                                                                        {note.description} ({note.description.length} کاراکتر)
                                                                    </div>
                                                                </div>
                                                            ))
                                                        }
                                                    </>
                                                ) : (
                                                    <div>یادداشتی جهت نمایش وجود ندارد.</div>
                                                )
                                            }


                                        </div>
                                        <div className="messaging center-block">
                                            <div className="row">
                                                <div className="col-md-12">
                                                    <form onSubmit={RahpardaznetSubmitMessage} className='rahpdrdaznet-border-bottom'>
                                                        <div className="input-group">
                                                            <input type="text" className="rahpardaznet-form-message"
                                                                value={RahpardaznetMessage}
                                                                onChange={(e) => setRahpardaznetMessage(e.target.value)}
                                                                placeholder="توضیحات را وارد نمایید." />

                                                            <button className="rahpardaznet-button-send-message"
                                                                type="submit">ثبت
                                                            </button>

                                                        </div>
                                                    </form>
                                                </div>
                                                <div className='col-md-12'>
                                                    <div
                                                        className="form-check rahpdrdaznet-border-bottom">
                                                        <input className="form-check-input"
                                                            type="checkbox" value=""
                                                            id="rahpardaznet-receipt-status"
                                                            onChange={(e) => setRahpardaznetNoteMessageStatus(e.target.checked)} />
                                                        {
                                                            (RahpardaznetNoteMessageStatus == true) ? (
                                                                <label
                                                                    className="form-check-label text-success"
                                                                    htmlhtmlFor="rahpardaznet-receipt-status">پیامک برای مشتری ارسال می شود</label>

                                                            ) : (
                                                                <label
                                                                    className="form-check-label text-danger"
                                                                    htmlhtmlFor="rahpardaznet-receipt-status">عدم ارسال پیامک برای مشتری</label>

                                                            )
                                                        }
                                                    </div>
                                                </div>
                                                {
                                                    (RahpardaznetNoteMessageStatus == true) ? (
                                                        <div className='col-md-12'>
                                                            <div
                                                                className="form-check rahpdrdaznet-border-bottom">
                                                                <input className="form-check-input"
                                                                    type="checkbox" value=""
                                                                    id="rahpardaznet-receipt"
                                                                    onChange={(e) => setRahpardaznetNoteMessage(e.target.checked)} />
                                                                {
                                                                    (RahpardaznetNoteMessage == true) ? (
                                                                        <label
                                                                            className="form-check-label text-success"
                                                                            htmlhtmlFor="rahpardaznet-receipt">آخرین یادداشت همراه
                                                                            پیامک برای مشتری ارسال می شود.</label>

                                                                    ) : (
                                                                        <label
                                                                            className="form-check-label text-danger"
                                                                            htmlhtmlFor="rahpardaznet-receipt">عدم ارسال یادداشت در
                                                                            پیامک ارسالی به مشتری</label>

                                                                    )
                                                                }
                                                            </div>
                                                        </div>
                                                    ) : null
                                                }

                                                <div className='col-md-12'>
                                                    <div className='rahpardaznet-default-note-message'>
                                                        <button type="button" onClick={(e) => RahpardaznetDefaultNote('یادداشت شماره ۱')}>یادداشت شماره ۱</button>
                                                        <button type="button" onClick={(e) => RahpardaznetDefaultNote('یادداشت شماره ۲')}>یادداشت شماره ۲</button>
                                                        <button type="button" onClick={(e) => RahpardaznetDefaultNote('یادداشت شماره ۳')}>یادداشت شماره ۳</button>
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                                <div className="col-12 border-top mt-3 pt-3 text-left">
                                    <button className="rahpardaznet-button" onClick={RahpardaznetSubmitChangeStatus} type="button">
                                        ذخیره تغیرات
                                    </button>
                                </div>
                            </div>


                        </div>
                    </div>
                </div>
            </div>
            <button type="button" className="d-none modalOwnerMobile" data-toggle="modal" data-backdrop="static"
                data-keyboard="false" data-target="#modalOwnerMobile"></button>

            <div className="modal fade" id="modalOwnerMobile">
                <div className="modal-dialog modal-dialog-centered" role="document">
                    <div className="modal-content">
                        <div className="modal-header">
                            <h5 className="modal-title" id="exampleModalLabel">اعتبار سنجی شماره موبایل مالک</h5>
                            <button type="button" className="close" data-dismiss="modal" aria-label="Close">
                                <span aria-hidden="true">&times;</span>
                            </button>
                        </div>
                        <input type="hidden" value={RahpardaznetHash ? RahpardaznetHash : null}
                            onChange={(e) => setRahpardaznetHash(e.target.value)} />
                        <div className="modal-body">
                            {(RahpardaznetValidationStatus == '1') ? (
                                <>
                                    <div className="input-group mb-3">
                                        <div className="input-group-prepend">
                                            <span className="input-group-text"
                                                id="inputGroup-sizing-default">کد تایید</span>
                                        </div>
                                        <input type="text" className="form-control rahpardaznet-mobile-border"
                                            aria-label="Default" aria-describedby="inputGroup-sizing-default"
                                            value={RahpardaznetCode ? RahpardaznetCode : null}
                                            onChange={(e) => setRahpardaznetCode(e.target.value)} />
                                    </div>
                                    <div className='rahpardaznet-modal-footer'>
                                        <button type="submit" onClick={validationCodeHandler}> {BtnSms == '1' ? (
                                            <div className="spinner-border text-light"
                                                role="status"></div>) : "اعتبارسنجی"}</button>
                                    </div>
                                </>
                            ) : (
                                <>
                                    <div className="input-group mb-3">
                                        <div className="input-group-prepend">
                                            <span className="input-group-text"
                                                id="inputGroup-sizing-default">شماره موبایل</span>
                                        </div>
                                        <input type="text" className="form-control rahpardaznet-mobile-border"
                                            aria-label="Default" aria-describedby="inputGroup-sizing-default"
                                            value={RahpardaznetMobile ? RahpardaznetMobile : null}
                                            onChange={(e) => setًRahpardaznetMobile(e.target.value)} />
                                    </div>
                                    <div className='rahpardaznet-modal-footer'>
                                        <button onClick={VerificationCodeHandler}>{BtnSms == '1' ? (
                                            <div className="spinner-border text-light"
                                                role="status"></div>) : "ارسال کد"}</button>
                                    </div>
                                </>
                            )}


                        </div>
                    </div>
                </div>
            </div>
            {(loading || RahpardaznetLoading == '1') ? <Loading /> : ''}

            <Broadcast title={'مدیریت سند'} />
            <div className='row rahpardaznet-cart  my-5  print-position'>
                <Header title='خروجی اکسل' />
                <div className='row'>
                    <div className='col-12 d-flex'>
                        <div className='rahpardaznet-excel-form d-grid'>
                            <label>کاربر</label>
                            <select
                                id="rahpardaznet-change-select"
                                value={RahpardaznetFilterUser ? RahpardaznetFilterUser : '0'}
                                onChange={(e) => setRahpardaznetFilterUser(e.target.value)}
                            >
                                <option value="0">انتخاب کنید ....</option>
                                {
                                    users.length > 0 ? (

                                        users.map((row, key) => (
                                            <option value={row.id}>{row.name}</option>
                                        ))
                                    ) : null
                                }
                            </select>
                        </div><div className='rahpardaznet-excel-form d-grid'>
                            <label>وضعیت</label>
                            <select
                                value={RahpardaznetFilterStatus ? RahpardaznetFilterStatus : '0'}
                                onChange={(e) => setRahpardaznetFilterStatus(e.target.value)}
                            >
                                <option value="0">انتخاب کنید ....</option>
                                {
                                    statuses.length > 0 ? (

                                        statuses.map((row, key) => (
                                            <option value={row.id}>{row.name}</option>
                                        ))
                                    ) : null
                                }
                            </select>
                        </div>
                        <div className='rahpardaznet-excel-form d-grid'>
                            <label>نوع سند</label>
                            <select
                                value={RahpardaznetFilterType ? RahpardaznetFilterType : '1'}
                                onChange={(e) => setRahpardaznetFilterType(e.target.value)}
                            >
                                <option value="1">همه سند ها</option>
                                <option value="2">سند های انتقالی</option>
                                <option value="3">سندهای فاقد مالک</option>
                                <option value="4">سندهای ناموجود</option>
                            </select>

                        </div>
                        <div className='rahpardaznet-excel-form d-grid'>
                            <label>از تاریخ</label>
                            <DatePicker
                                tabIndex="1"
                                calendar={persian}
                                locale={persian_fa}
                                calendarPosition="bottom-right"
                                value={start_date.date ? start_date.date : null}
                                onChange={convert_start}
                            />
                        </div>
                        <div className='rahpardaznet-excel-form d-grid'>
                            <label>تا تاریخ</label>
                            <DatePicker
                                tabIndex="2"
                                calendar={persian}
                                locale={persian_fa}
                                calendarPosition="bottom-right"
                                value={end_date.date ? end_date.date : null}
                                onChange={convert_end}
                            />
                        </div>
                        <div className='rahpardaznet-excel-form'>
                            <button type="button" className='rahpardaznet-btn-inline'
                                onClick={rahpardaznetFilterRequest}>جستجو
                            </button>
                        </div>
                        <div className='rahpardaznet-excel-form'>
                            <button type="button" className='rahpardaznet-btn-inline'
                                onClick={rahpardaznetExportExcel}> اکسل
                            </button>
                        </div>
                        <div className='rahpardaznet-excel-form'>
                            <button className='rahpardaznet-btn-outline' onClick={rahpardazneRestForm}>پاکسازی</button>
                        </div>


                    </div>
                </div>

            </div>

            <div className='row g-2 pr-3 pl-3 pb-4'>

                <div className="App">
                    <form onSubmit={rahkarpardaznet_search_datatable} className="rk-search-bar">
                        <input type="text" id="" placeholder='جستجو کنید'
                            onChange={(event) => setPinCode(event.target.value)} />
                        <button type="submit"><Icon.Search /></button>

                    </form>
                    <DataTable
                        title=""
                        columns={columns}
                        data={ListDocument.data}
                        highlightOnHover
                        pagination
                        paginationServer
                        paginationTotalRows={ListDocument.total}
                        paginationPerPage={countPerPage}
                        paginationComponentOptions={{
                            noRowsPerPage: true
                        }}
                        expandableRows
                        expandableRowExpanded={row => row.defaultExpanded}
                        expandableRowsComponent={ExpandedComponent}
                        onChangePage={handlePageChange}
                    />
                </div>


            </div>

        </>
    )
}

export default DocumentIndex;